//Paquetes NPM de GYF.
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, ConciergeProxy, LogsProxy } from 'com-gyf-webcore-servicehub';

//Exportación de constantes
export const SET_FUNCTIONS_PROFILE_TO_USER = 'SET_FUNCTIONS_PROFILE_TO_USER';
export const GET_DATA_USERS_PROFILE_TO_USER_START = 'GET_DATA_USERS_PROFILE_TO_USER_START';
export const GET_DATA_USERS_PROFILE_TO_USER_SUCCESS = 'GET_DATA_USERS_PROFILE_TO_USER_SUCCESS'; 

export const SEARCH_USERS_TO_PROFILE = 'SEARCH_USERS_TO_PROFILE';
export const SET_ACTIVOS_CHECKBOX_USERS_TO_PROFILE = 'SET_ACTIVOS_CHECKBOX_USERS_TO_PROFILE';
export const SET_BLOQUEADOS_CHECKBOX_USERS_TO_PROFILE = 'SET_BLOQUEADOS_CHECKBOX_USERS_TO_PROFILE';
export const SET_ELIMINADOS_CHECKBOX_USERS_TO_PROFILE = 'SET_ELIMINADOS_CHECKBOX_USERS_TO_PROFILE';
export const SET_ALL_CHECKBOX_USERS_TO_PROFILE = 'SET_ALL_CHECKBOX_USERS_TO_PROFILE';
export const INITIAL_STATE_USERS_TO_PROFILE = "INITIAL_STATE_USERS_TO_PROFILE";

export const FILTER_ORDER_COLUMN_USERS_TO_PROFILE = 'FILTER_ORDER_COLUMN_USERS_TO_PROFILE';
export const FILTER_CHECKBOX_USERS_TO_PROFILE = 'FILTER_CHECKBOX_USERS_TO_PROFILE';
export const SET_TITLE_USERS_TO_PROFILE = 'SET_TITLE_USERS_TO_PROFILE';
export const DO_TRANSACTION_ASIGNAR_PERFIL_SUCCESS = 'DO_TRANSACTION_ASIGNAR_PERFIL_SUCCESS';
export const DO_TRANSACTION_ASIGNAR_PERFIL_FAILED = 'DO_TRANSACTION_ASIGNAR_PERFIL_FAILED';
export const DO_TRANSACTION_ASIGNAR_PERFIL_START = 'DO_TRANSACTION_ASIGNAR_PERFIL_START';
export const ESCONDER_POPUP_ASIGNARPERFILAUSUARIO = 'ESCONDER_POPUP_ASIGNARPERFILAUSUARIO';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _currentScope = null;
let _profileId = null;
let _title2 = null;
let _tipoOperacion = null;
/**
 * Obtiene los datos para popular la pantalla.
 * @param {any} state
 * @param {any} currentScope
 */
export function getScreenData(id, currentScope) {
    LogHelper.In(getScreenData.name, id, currentScope);

    return (dispatch, getState) => {
        const state = getState();
        _dispatch = dispatch;
        _currentScope = currentScope;
        _profileId = id.substring(0, id.length - 1); // obtengo el idPerfil
        _title2 = null;
        _tipoOperacion = id.charAt(id.length - 1); // obtengo el tipo de operación
        dispatch({ type: GET_DATA_USERS_PROFILE_TO_USER_START, state, currentUser: _currentScope.UserId });

        var currentScopeRequest = {
            "UserId": _currentScope.UserId,
            "ProductCode": _currentScope.ProductCode,
            "ProgramCode": _currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => getFunctionsCallback(data), null, "GETFUNCTIONS", currentScopeRequest, null, "SEGURIDAD");
    }
}

/**
 * Vuelve el estado de la pantalla al inicial de la misma.
 * @param {any} currentScope
 */
export function resetStateAsignPerfUsr() {

    LogHelper.In(resetStateAsignPerfUsr.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_USERS_TO_PROFILE });
    }
}


/**
 * Se filtran los usuarios por texto.
 * @param {any} user
 */
export function searchUser(user) {
    LogHelper.In(searchUser.name, user);
    return (dispatch) => {
        dispatch({ type: SEARCH_USERS_TO_PROFILE, user: user });
    }
}

/**
 Esconde o muestra el popup de error.
 */
export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_ASIGNARPERFILAUSUARIO });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} activo
 */
export function setActivosCheckbox(activo) {
    LogHelper.In(setActivosCheckbox.name, activo);
    return (dispatch) => {
        dispatch({ type: SET_ACTIVOS_CHECKBOX_USERS_TO_PROFILE, activo: activo });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} bloqueado
 */
export function setBloqueadosCheckbox(bloqueado) {
    LogHelper.In(setBloqueadosCheckbox.name, bloqueado);
    return (dispatch) => {
        dispatch({ type: SET_BLOQUEADOS_CHECKBOX_USERS_TO_PROFILE, bloqueado: bloqueado });
    }
}

/**
 * Se setea el valor del checkbox de activos.
 * @param {any} eliminado
 */
export function setEliminadosCheckbox(eliminado) {
    LogHelper.In(setEliminadosCheckbox.name, eliminado);
    return (dispatch) => {
        dispatch({ type: SET_ELIMINADOS_CHECKBOX_USERS_TO_PROFILE, eliminado: eliminado });
    }
}

/**
 * Se ordena la tabla por una columna.
 * @param {any} columnIndex
 */
export function orderColumn(columnIndex) {
    LogHelper.In(orderColumn.name, columnIndex);
    return (dispatch, getState) => {
        dispatch({ type: FILTER_ORDER_COLUMN_USERS_TO_PROFILE, columnIndex: columnIndex });
    }
}

/**
 * Se setea el valor de todos los checkbox de la tabla.
 * @param {any} allCheckboxFilter
 */
export function setAllCheckbox(allCheckboxFilter, currentUser) {
    LogHelper.In(setAllCheckbox.name, allCheckboxFilter, currentUser);
    return (dispatch) => {
        dispatch({ type: SET_ALL_CHECKBOX_USERS_TO_PROFILE, allCheckboxFilter: allCheckboxFilter, currentUser: currentUser });
    }
}

/**
 * Setea el valor de un checkbox de la tabla.
 * @param {any} usuarioId
 */
export function setCheckbox(usuarioId) {
    LogHelper.In(setCheckbox.name, usuarioId);
    return (dispatch) => {
        dispatch({ type: FILTER_CHECKBOX_USERS_TO_PROFILE, usuarioId: usuarioId });
    }
}

/**
 * Asigna perfil a usuario/s.
 * @param {any} usuariosSeleccionados
 */
export function asignarPerfil(usuariosSeleccionados){    
    LogHelper.In(asignarPerfil.name, usuariosSeleccionados);

    return (dispatch, getState) => {
        const state = getState();

        if (usuariosSeleccionados.length != 0) {
            let profiles = [];
            let params = {};

            usuariosSeleccionados.forEach(function (row) {
                params = {
                    "CURRENT_USER": row.Id,
                    "PERFIL_ID": _profileId
                }

                profiles.push(params);
            });

            if (profiles.length > 0) {
                Engine1Proxy.AddRuleRequests({ Profiles: profiles }, "CreateUsuarioPerfil", _currentScope.ProductCode, "SEGURIDAD");
                Engine1Proxy.Execute((data) => insertProfileToUsersCallback(data, usuariosSeleccionados), null, null, "SEGURIDAD");
            }
        }
    }
}

/**
 * Quitar perfil a usuario/s.
 * @param {any} usuariosSeleccionados
 */
export function desasignarPerfil(usuariosSeleccionados) {
    LogHelper.In(desasignarPerfil.name, usuariosSeleccionados);

    return (dispatch, getState) => {
        const state = getState();

        if (usuariosSeleccionados.length != 0) {
            let profiles = [];
            let params = {};

            usuariosSeleccionados.forEach(function (row) {
                params = {
                    "ID_USUARIO": row.Id,
                    "ID_PERFIL": _profileId
                }
                Engine1Proxy.AddDataSourcesRequests(params, 'DELETE_PERFIL_USUARIO_BY_USUARIO_PERFIL', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product', true, 'DELETE_PERFIL_USUARIO_BY_USUARIO_PERFIL_' + row.Id);
                //profiles.push(params);
                
            });


            //Engine1Proxy.AddRuleRequests({ Profiles: profiles }, "DeleteUsuarioPerfilByUsuarioPerfil", _currentScope.ProductCode, "SEGURIDAD");
            Engine1Proxy.Execute((data) => deleteProfileToUsersCallback(data, usuariosSeleccionados), null, null, "SEGURIDAD");
        }
    }
}

/**--------------------------------------- FUNCIONES AUXILIARES ---------------------------------------**/

/**
 * Funcion callback de la obtencion de las funciones del usuario.
 * @param {any} data
 */
function getFunctionsCallback(data) {
    LogHelper.In(getFunctionsCallback.name, data);

    let functions = data.SEGURIDAD;
    functions.forEach(p => { functions[p.Codigo_Funcion] = true; });

    _dispatch({ type: SET_FUNCTIONS_PROFILE_TO_USER, functions });

    let paramProfile = {
        'PERFIL_ID': _profileId
    }

    if (functions.Consulta == true) {

        if (_tipoOperacion == 1) {
            Engine1Proxy.AddDataSourcesRequests(paramProfile, 'GET_USERS_BY_DISTINCT_PROFILE', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        } else {
            Engine1Proxy.AddDataSourcesRequests(paramProfile, 'GET_USERS_BY_DISTINCT_PROFILE_FOR_DESASIGNAR', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');
        }
        Engine1Proxy.AddDataSourcesRequests(paramProfile, 'GET_PERFIL_BY_ID', 'Get', _currentScope.ProductCode, "SEGURIDAD", _currentScope.ProgramCode, 'Product');

        Engine1Proxy.Execute(getDataCallback, null, null, "SEGURIDAD");
    }
}

/**
 * Funcion callback de la obtencion de los datos principales para popular la pantalla.
 * @param {any} data
 */
function getDataCallback(data) {
    LogHelper.In(getDataCallback.name, data);

    let result = null;
    if (data.GET_USERS_BY_DISTINCT_PROFILE_FOR_DESASIGNAR != undefined)
        result = JSON.parse(data.GET_USERS_BY_DISTINCT_PROFILE_FOR_DESASIGNAR).Recordset0.Rows

    if (data.GET_USERS_BY_DISTINCT_PROFILE != undefined)
        result = JSON.parse(data.GET_USERS_BY_DISTINCT_PROFILE).Recordset0.Rows;

    if (!_title2 && JSON.parse(data.GET_PERFIL_BY_ID).Recordset0.Rows != undefined) {
        _title2 = JSON.parse(data.GET_PERFIL_BY_ID).Recordset0.Rows;
        _dispatch({ type: SET_TITLE_USERS_TO_PROFILE, _title2 });
    }

    _dispatch({ type: GET_DATA_USERS_PROFILE_TO_USER_SUCCESS, result });
}

/**
 * Funcion callback de la insercion de los usuarios
 * @param {any} data
 * @param {any} usuariosSeleccionados
 */
function insertProfileToUsersCallback(data, usuariosSeleccionados) {
    LogHelper.In(insertProfileToUsersCallback.name, data, usuariosSeleccionados);
    let action = "";
    if (data) {
        usuariosSeleccionados.forEach((row) => {
            action += ("Usuario " + row.Nombre + ". Perfil asignado: " + _title2[0].Descripcion) + " ";             
        });


        LogsProxy.SaveOperationLog("SEGURIDAD,MODIFICACION,PERMISO,USUARIO",action + ". (Usuario asignado masivamente)",
                null, null, null /*saveLogCallback*/, null, null, "SEGURIDAD");

        _dispatch({ type: DO_TRANSACTION_ASIGNAR_PERFIL_SUCCESS, data });
    }
    else {
        _dispatch({ type: DO_TRANSACTION_ASIGNAR_PERFIL_FAILED, data });
    }
}


/**
 * Funcion callback de la eliminación de los usuarios
 * @param {any} data
 * @param {any} usuariosSeleccionados
 */
function deleteProfileToUsersCallback(data, usuariosSeleccionados) {
    LogHelper.In(deleteProfileToUsersCallback.name, data, usuariosSeleccionados);

    let action = "";

    usuariosSeleccionados.forEach(function (row) {

        action += ("Usuario " + row.Nombre + ". Perfil des-asignado: " + _title2[0].Descripcion + ". (Usuario des-asignado masivamente)") + " ";

    });


    if (data) {
        LogsProxy.SaveOperationLog("SEGURIDAD,MODIFICACION,PERMISO,USUARIO", action, null, null, null /*saveLogCallback*/, null, null, "SEGURIDAD");

        _dispatch({ type: DO_TRANSACTION_ASIGNAR_PERFIL_SUCCESS, data });
    }
    else {
        _dispatch({ type: DO_TRANSACTION_ASIGNAR_PERFIL_FAILED, data });
    }
}
